import React, { useState } from 'react'

interface UiFileViewerProps {
  url: string
}

const UiFileViewer: React.FC<UiFileViewerProps> = ({ url }) => {
  const [scale, setScale] = useState(1) // State to manage zoom level

  const getFileExtension = (url: string): string => {
    const cleanUrl = url.split('?')[0]
    const extension = cleanUrl.split('.').pop()?.toLowerCase() || ''
    return ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'].includes(extension)
      ? extension
      : 'unknown'
  }

  const getViewerUrl = (url: string): string => {
    const fileType = getFileExtension(url)
    if (fileType === 'pdf') {
      return url
    } else if (fileType === 'doc' || fileType === 'docx') {
      return `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`
    } else {
      console.warn(`Unsupported file type: ${fileType}`)
      return url
    }
  }
  const fileType = getFileExtension(url)
  // Zoom in and out functions
  const zoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.1, 3)) // Max zoom level of 3
  }

  const zoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.1, 1)) // Min zoom level of 1
  }
  console.log('filetype', fileType)
  return (
    <div style={{ width: '100%', height: '500px' }}>
      {fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' ? (
        <iframe
          src={getViewerUrl(url)}
          width="100%"
          height="100%"
          frameBorder="0"
          title="File Viewer"
        />
      ) : fileType === 'jpg' ||
        fileType === 'jpeg' ||
        fileType === 'png' ||
        fileType === 'gif' ||
        fileType === 'svg' ? (
        <div
          style={{
            overflow: 'hidden',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={url}
            alt="File Preview"
            style={{
              transform: `scale(${scale})`, // Apply scaling
              transition: 'transform 0.2s ease-in-out', // Smooth transition
              maxWidth: 'none', // Prevent default max width
              maxHeight: 'none', // Prevent default max height
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
          <div style={{ position: 'absolute', top: '80px', right: '10px' }}>
            <button onClick={zoomIn} style={{ margin: '0 5px' }}>
              +
            </button>
            <button onClick={zoomOut} style={{ margin: '0 5px' }}>
              -
            </button>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p>Unsupported file type: {fileType}</p>
        </div>
      )}
    </div>
  )
}

export default UiFileViewer
